import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import "./ResultsTable.css"
import {ThemeProvider} from "@material-ui/core/styles";
import ResultsTableAppBar from "./ResultsTableAppBar";

export default function ResultsTable(props) {

    const data = props.location.state.data;
    const currentView = props.location.state.currentView;
    const sessionData = props.location.state.sessionData;

    return (
        <ThemeProvider>
            <ResultsTableAppBar currentView={currentView} sessionData={sessionData}/>
            {currentView === "Teams" ?
                <div className="result">
                    <div>
                        <div className="header">
                            מועמדים
                        </div>
                        <Grid container spacing={2} dir="rtl">
                            {data.classes.map((row, i) => (
                                <Grid item key={i}>
                                    <Typography variant="h6" className="class">
                                        כיתה{' '}{row.id}
                                    </Typography>
                                    <div>
                                        <List dense={true}>
                                            {row.candidates.map((candidate, i) => (
                                                <ListItem key={i}>
                                                    <ListItemText
                                                        className="name"
                                                        primary={candidate.name}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                    <div>
                        <div className="header">
                            מעריכים
                        </div>
                        <Grid container spacing={2} dir="rtl">
                            {data.classes.map((row, i) => (
                                <Grid item key={i}>
                                    <Typography variant="h6" className="class">
                                        כיתה{' '}{row.id}
                                    </Typography>
                                    <div>
                                        <List dense={true}>
                                            {row.reviewers.map((reviewer, i) => (
                                                <ListItem key={i}>
                                                    <ListItemText
                                                        className="name"
                                                        primary={reviewer.name}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                </div> :
                <div className="interviewsResult">
                    <div>
                        <div className="header">
                            מועמדים
                        </div>
                        <Grid container spacing={2} dir="rtl">
                            <Grid item>
                                <Typography variant="h6" className="class">
                                    שעה
                                </Typography>
                                <div>
                                    <List dense={true}>
                                        {data.times.map((time, i) => (
                                            <ListItem key={i}>
                                                <ListItemText
                                                    className="name"
                                                    primary={time}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                            </Grid>
                            {data.classes.map((row, i) => (
                                <Grid item key={i}>
                                    <Typography variant="h6" className="class">
                                        כיתה{' '}{row.id}
                                    </Typography>
                                    <div>
                                        <List dense={true}>
                                            <ListItem key={i}>
                                                {row.interviews[data.times[0]] ?
                                                    <ListItemText
                                                        className="name"
                                                        primary={row.interviews[data.times[0]].name}
                                                    /> :
                                                    <ListItemText
                                                        className="name"
                                                        primary=""
                                                    />}
                                            </ListItem>
                                            <ListItem key={i}>
                                                {row.interviews[data.times[1]] ?
                                                    <ListItemText
                                                        className="name"
                                                        primary={row.interviews[data.times[1]].name}
                                                    /> :
                                                    <ListItemText
                                                        className="name"
                                                        primary=""
                                                    />}
                                            </ListItem>
                                        </List>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                    <div>
                        <div className="interviewsHeader">
                            מעריכים
                        </div>
                        <Grid container spacing={2} dir="rtl">
                            <Grid item>
                                <Typography variant="h6" className="class">
                                    שעה
                                </Typography>
                                <div>
                                    <List dense={true}>
                                        {data.times.map((time, i) => (
                                            <ListItem key={i}>
                                                <ListItemText
                                                    className="name"
                                                    primary={time}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </div>
                            </Grid>
                            {data.classes.map((row, i) => (
                                <Grid item key={i}>
                                    <Typography variant="h6" className="class">
                                        כיתה{' '}{row.id}
                                    </Typography>
                                    <div>
                                        <List dense={true}>
                                            {row.reviewers.map(reviewer => (
                                                <ListItem>
                                                    <ListItemText
                                                        className="name"
                                                        primary={reviewer.name}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                </div>}
        </ThemeProvider>)
}